import { isDevMode } from '@angular/core';
import * as i0 from "@angular/core";
/**
 * HTTP Interceptor performing request adjustments for easier REST API usage.
 *
 * This interceptor will turn on sending cookies along with the request, for each request of type different than
 * 'OPTIONS', using 'withCredentials' setting.
 */
var RestApiInterceptor = /** @class */ (function () {
    function RestApiInterceptor() {
    }
    RestApiInterceptor.prototype.intercept = function (request, nextHandler) {
        var preFlightRequest = this.isPreFlightRequest(request);
        var apiRequest = request.clone({
            url: request.url,
            withCredentials: preFlightRequest ? request.withCredentials : true
        });
        return nextHandler.handle(apiRequest);
    };
    RestApiInterceptor.prototype.isPreFlightRequest = function (request) {
        var result = ('OPTIONS' === request.method);
        if (result && isDevMode()) {
            console.log('PreFlight Request - Origin: ' + request.headers.get('ORIGIN') + ', ACRM: ' + request.headers.get('Access-Control-Request-Method'));
        }
        return result;
    };
    RestApiInterceptor.ngInjectableDef = i0.defineInjectable({ factory: function RestApiInterceptor_Factory() { return new RestApiInterceptor(); }, token: RestApiInterceptor, providedIn: "root" });
    return RestApiInterceptor;
}());
export { RestApiInterceptor };
